// extracted by mini-css-extract-plugin
module.exports = {"sidebarHeader":"ArticleSidebar_sidebarHeader__9IgsS","sidebarLinks":"ArticleSidebar_sidebarLinks__2wj1m","sidebarLink":"ArticleSidebar_sidebarLink__sr1zl"};